function boundedMilliseconds(
  value: string | undefined,
  fallback: number,
): number {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 15_000 && parsed <= 300_000
    ? parsed
    : fallback;
}

const config = {
  // API URLs
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://server.bambo.fund',
  MEDIA_SERVICE_URL: import.meta.env.VITE_MEDIA_SERVICE_URL || 'http://localhost:4002',
  SOCKET_URL:
    import.meta.env.VITE_SOCKET_URL ||
    (import.meta.env.MODE === 'development'
      ? 'http://localhost:4014'
      : 'https://socket.bambo.fund'),
  PUBLIC_SUPPORT_ADMIN_POLL_FALLBACK_MS: boundedMilliseconds(
    import.meta.env.VITE_PUBLIC_SUPPORT_ADMIN_POLL_FALLBACK_MS,
    60_000,
  ),
  
  // Other environment variables
  NODE_ENV: import.meta.env.MODE || 'development',
  IS_PRODUCTION: import.meta.env.MODE === 'production',
  IS_DEVELOPMENT: import.meta.env.MODE === 'development',
};

export default config;
